import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { cloneObject } from '../../../common/utils';

const LinkElement = React.forwardRef((props, ref) => {
  const externalUrlPattern = new RegExp('^(http:\\/\\/|www\\.|mailto:|tel:).*');
  const { to: linkTo } = props;
  const {
    children,
    isLinkExternal = externalUrlPattern.test(linkTo)
  } = props;

  const elementAttributes = cloneObject(props, {}, [
    'type',
    'isLinkExternal',
    'children',
    'href'
  ]);

  if (isLinkExternal) {
    const anchorAttributes = cloneObject(elementAttributes, {
      href: linkTo,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, ['to']);

    return <a ref={ref} {...anchorAttributes}>{children}</a>;
  }

  return <Link ref={ref} {...elementAttributes}>{children}</Link>;
});

LinkElement.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  isLinkExternal: PropTypes.bool
};

export default LinkElement;